import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import HeadingLines from '../assets/images/heading-lines.svg' 
import ErrorImg from '../assets/images/500.svg' 

function FourZeroFourErrorSection() {
  return (
    <> 
    <section className="error-section">
      <Container>
        <Row>
          <Col md="12">
              <div className="common-header">
                  <img src={HeadingLines} alt="" />
                  <span className='error-pill'>500 Error</span>
                  <h2>Internal Server Error</h2> 
                  <p>We’re working towards creating something better.<br/> We won’t  be long. Please try again later.</p>
              </div>
              <div className="error-page-box">
               <img src={ErrorImg} alt="" />
              </div>
          </Col>
        </Row>        
      </Container>
    </section>
    </>
  )
}
export default FourZeroFourErrorSection